const styles = theme => ({
    UploadDropArea: {
        width: '95%',
        padding: '10px 20px',
        opacity: '0.8',
        boxShadow: '2px 2px 5px rgba(200,200,200,0.6)',
        borderRadius: '10px',
    },
    dropArea: {
        boxingSize: 'border-box',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(240,240,240,1)',
        '&:hover':{
            backgroundColor: 'rgba(255,255,255,1)',
        },
        height: '100px',
        border: '2px dashed rgba(50,50,50,1)',
        borderRadius: '20px',
        boxShadow:  'inset 2px 2px 40px rgba(180,180,180,1)',
        '&:focus':{
            outline: 'none'
        }
    },
    dropAreaHover: {
        backgroundColor: 'rgba(255,255,255,1)',
    },
    dropAreaText: {
        '&:hover': {
            cursor: 'default'
        },
        maxWidth: '90%'
    },
    acceptFiles: {
        backgroundColor: 'rgba(100,255,100,1)',
        border: '2px solid rgba(50,150,50,1)'
    },
    rejectFiles: {
        backgroundColor: 'rgba(255,100,100,1)',
        border: '2px dashed rgba(150,50,50,1)'
    }
});

export default styles;
